var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPublished = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "currentcolor",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.293 1.25a1.229 1.229 0 0 1 1.227 1.229v11.044a1.227 1.227 0 0 1-1.227 1.227h-7.67a2.149 2.149 0 0 1-2.137-1.935l-.01-.213V3.398A2.148 2.148 0 0 1 4.622 1.25h7.67zm-7.67 10.433a.92.92 0 0 0-.92.92l.004.09a.923.923 0 0 0 .916.83h7.67v-1.84h-7.67zm0-9.204a.92.92 0 0 0-.92.92v7.265c.285-.135.598-.209.92-.209h7.67V2.48h-7.67zm4.78 2.326a.615.615 0 0 1 .869.868L7.818 8.127a.614.614 0 0 1-.868 0L5.722 6.9a.614.614 0 0 1 .868-.867l.793.792 2.02-2.02z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPublished);
export default ForwardRef;